import { render, staticRenderFns } from "./NotificationItemDropdown.vue?vue&type=template&id=2c13bdc4&"
import script from "./NotificationItemDropdown.vue?vue&type=script&lang=ts&"
export * from "./NotificationItemDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports